import { fetchSH } from './api'

const fetchAuthorizationToken = (callback) => {
  return fetchSH('cognitive/token')
    .then((res) => {
      const token = res.token
      const parsedToken = JSON.parse(atob(token.split('.')[1]))

      return callback(token, parsedToken.region)
    })
}

const fetchVoiceList = (locale, callback) => {
  return fetchSH(`cognitive/speech/voices/${locale}`)
    .then((res) => callback(res.name))
}

export default { fetchAuthorizationToken, fetchVoiceList }
